
(function($){

  var PRODUCT_ID    = '7074931605622';
  var MAX_ATTENDEES = 6;

  console.log("Attendee-overlay for id: "+PRODUCT_ID);

  var sel = {
    overlay:            '.attendeeOverlay',
    overlayHiddenClass: 'is-hidden',
    groupsSingle:       '.attendeeGroups.layout-single',
    groupsTwoCols:      '.attendeeGroups.layout-twoCols',
    errorRow:           '.feedbackRow .errorMessage',
    ctaBtn:             '#attendeeAddToCart',
    closeBtn:           '.closeWrap .closeBtn',

    form:               '#product_form_' + PRODUCT_ID,
    qty:                '#Quantity-product-template, .product-form__input--quantity[name="quantity"], input[name="quantity"]',
    submitBtn:          '.product-form__cart-submit',

    buyNowBtn:          '.shopify-payment-button__button',
    buyNowContainer:    '[data-shopify="payment-button"]',

    hiddenSink:         '#AttendeeHidden'
  };

  $(function(){
    var $form = $(sel.form);
    if (!$form.length) { console.log('[overlay] Product form not found.'); return; }

    if (!$form.find(sel.hiddenSink).length) {
      $form.append('<div id="AttendeeHidden"></div><!-- AttendeeHidden -->');
    }

    /* 1) Intercept the Add-to-basket BUTTON click and stop other handlers */
    $(document).on('click', sel.submitBtn, function(e){
      e.preventDefault();
      e.stopImmediatePropagation(); //
      var $form = $(this).closest('form');
      var qty = clamp(getQty($form), 1, MAX_ATTENDEES);
      console.log('[overlay] Add-to-basket click intercepted. Qty:', qty);
      openOverlayWith(qty);
      return false;
    });

    /* 2) Intercept the FORM submit and block unless overlay explicitly allows */
    $(document).on('submit', sel.form, function(e){
      var $f = $(this);
      var allow = $f.data('overlay-allow') === true;
      if (!allow) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var qty = clamp(getQty($f), 1, MAX_ATTENDEES);
        console.log('[overlay] Submit intercepted (not allowed yet). Opening overlay. Qty:', qty);
        openOverlayWith(qty);
        return false;
      } else {
        
        $f.removeData('overlay-allow');
        console.log('[overlay] Submit allowed through.');
      }
    });

    /* Intercept Buy It Now (if visible) */
    $(document).on('click', sel.buyNowBtn, function(e){
      e.preventDefault(); e.stopImmediatePropagation();
      var qty = clamp(getQty($form), 1, MAX_ATTENDEES);
      console.log('[overlay] Buy Now intercepted. Qty:', qty);
      openOverlayWith(qty);
      return false;
    });
    $(document).on('click', sel.buyNowContainer, function(e){
      if ($(e.target).is(sel.buyNowBtn)) return;
      var $btn = $(this).find(sel.buyNowBtn);
      if ($btn.length) {
        e.preventDefault(); e.stopImmediatePropagation();
        var qty = clamp(getQty($form), 1, MAX_ATTENDEES);
        console.log('[overlay] Buy Now container intercepted. Qty:', qty);
        openOverlayWith(qty);
        return false;
      }
    });

    /* Overlay CTA */
    $(document).on('click', sel.ctaBtn, function(){
      console.log('[overlay] Overlay CTA clicked. Validating…');
      var $ov = $(sel.overlay);
      var groups = collectGroups($ov);
      var check = validate(groups.$groups);
      if (!check.valid) { setError(check.message); return; }

      clearError();
      mirrorToHidden($form, groups.data);
      closeOverlay();

      // 3) Allow a single real submit and use the NATIVE submit (bypasses jQuery handlers)
      $form.data('overlay-allow', true);
      $form.get(0).submit(); // <-- real add to cart happens here, and only here
    });

    /* Close + cleanup */
    $(document).on('click', sel.closeBtn, closeOverlay);
    $(document).on('keydown', function(evt){ if (evt.key === 'Escape') closeOverlay(); });
    $(document).on('input change', '.attendeeOverlay input', function(){ $(this).removeClass('is-invalid'); clearError(); });

  });

  //helpers
  function getQty($form){
    var $q = $form.find(sel.qty).first();
    var v = parseInt($q.val(), 10);
    return (isNaN(v)) ? 1 : v;
  }
  function clamp(n, min, max){ return Math.max(min, Math.min(max, n)); }
  function openOverlayWith(qty){
    var $ov = $(sel.overlay), $one = $ov.find(sel.groupsSingle), $grid = $ov.find(sel.groupsTwoCols);
    $one.empty(); $grid.empty();
    if (qty === 1) { $one.append(buildGroupHtml(1)); $one.show(); $grid.hide(); }
    else { for (var i=1;i<=qty;i++) { $grid.append(buildGroupHtml(i)); } $grid.show(); $one.hide(); }
    clearError(); openOverlay();
  }
  function openOverlay(){ $(sel.overlay).removeClass(sel.overlayHiddenClass); }
  function closeOverlay(){ $(sel.overlay).addClass(sel.overlayHiddenClass); }
  function buildGroupHtml(i){
    var idx = String(i);
    return '' +
      '<div class="attendeeGroup" data-index="'+idx+'"><!-- attendeeGroup -->' +
        '<h3>Attendee '+idx+'</h3>' +
        '<div class="fieldsGrid"><!-- fieldsGrid -->' +
          '<div class="attendeeField"><!-- attendeeField -->' +
            '<label for="first_name_'+idx+'">First name<sup>*</sup></label>' +
            '<input type="text" id="first_name_'+idx+'" name="first_name_'+idx+'" data-key="First name" required>' +
          '</div><!-- attendeeField -->' +
          '<div class="attendeeField"><!-- attendeeField -->' +
            '<label for="last_name_'+idx+'">Last name<sup>*</sup></label>' +
            '<input type="text" id="last_name_'+idx+'" name="last_name_'+idx+'" data-key="Last name" required>' +
          '</div><!-- attendeeField -->' +
          '<div class="attendeeField full"><!-- attendeeField full -->' +
            '<label for="email_'+idx+'">Email address<sup>*</sup></label>' +
            '<input type="email" id="email_'+idx+'" name="email_'+idx+'" data-key="Email address" required>' +
          '</div><!-- attendeeField full -->' +
        '</div><!-- fieldsGrid -->' +
      '</div><!-- attendeeGroup -->';
  }
  function collectGroups($ov){
    var $groups = $ov.find('.attendeeGroup'); var rows = [];
    $groups.each(function(){
      var $g = $(this), i = parseInt($g.attr('data-index'), 10);
      rows.push({ i:i, first:$('#first_name_'+i).val()||'', last:$('#last_name_'+i).val()||'', email:$('#email_'+i).val()||'' });
    });
    return { $groups:$groups, data:rows };
  }
  function validate($groups){
    var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; var firstMessage = '';
    $groups.find('input').removeClass('is-invalid');
    $groups.each(function(){
      var i = $(this).attr('data-index'), $first=$('#first_name_'+i), $last=$('#last_name_'+i), $email=$('#email_'+i), e=$email.val().trim();
      if (!$first.val().trim()) { $first.addClass('is-invalid'); if (!firstMessage) firstMessage = 'Please enter ‘Attendee '+i+'’ first name.'; }
      if (!$last.val().trim())  { $last.addClass('is-invalid');  if (!firstMessage) firstMessage = 'Please enter ‘Attendee '+i+'’ last name.'; }
      if (!e || !emailRe.test(e)) { $email.addClass('is-invalid'); if (!firstMessage) firstMessage = 'Please enter ‘Attendee '+i+'’ email address.'; }
    });
    return { valid: firstMessage === '', message: firstMessage };
  }
  function setError(msg){ $(sel.errorRow).text(msg).show(); }
  function clearError(){ $(sel.errorRow).hide().text(''); }
  function mirrorToHidden($form, rows){
    var $sink = $form.find(sel.hiddenSink); $sink.empty();
    for (var r=0;r<rows.length;r++){
      var row = rows[r];
      addHidden($sink, 'Attendee ' + row.i + ' - First name', row.first);
      addHidden($sink, 'Attendee ' + row.i + ' - Last name',  row.last);
      addHidden($sink, 'Attendee ' + row.i + ' - Email',      row.email);
    }
  }
  function addHidden($target, key, value){
    $target.append($('<input>', { type:'hidden', name:'properties['+key+']', value:value }));
  }

})(window.jQuery);
